define('glu/grid/filter/exclusiveFilterProcessor',['require','./filterProcessor'],function(require) {
    'use strict';

    var FilterProcessor = require('./filterProcessor');

    return FilterProcessor.extend({
        addFilter: function(filter) {
            var model = this.filters.find(function(itr) {
                return itr.get('field') === filter.field;
            });

            if (filter.label) {
                if (model) {
                    model.set(filter);
                } else {
                    this.filters.add(filter);
                }
                this.trigger('add', filter, this.filters);
            }

            this.process();
        }
    });
});

